import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SharedModule } from 'shared/shared.module';

import { ReceiverLogsTabComponent } from './receiver-logs.component';
import { ExportLogsComponent } from './export-logs/export-logs.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
    ],
    declarations: [
        ReceiverLogsTabComponent,
        ExportLogsComponent,
    ],
    exports: [ReceiverLogsTabComponent]
})
export class ReceiverLogsModule {}
